import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: {},
  isLoggedIn: false,
  accessToken: null,
  vettingForm: {},
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => ({
      ...state,
      user: action.payload,
      isLoggedIn: true,
    }),
    logout: () => ({
      ...initialState
    }),
    setAccessToken: (state, action) => ({
      ...state,
      accessToken: action.payload,
      isLoggedIn: true,
    }),
    removeAccessToken: (state, action) => {
      state.isLoggedIn = false
      return {
        isLoggedIn: false,
        accessToken: null
      }
    },
    setVettingForm: (state, action) => {
      return {
        ...state,
        vettingForm: action.payload,
      };
    },
    removeVettingFrom: (state, action) => ({
      ...state,
      vettingForm: {},
    }),
  },
});

export const {
  setUser,
  logout,
  setAccessToken,
  removeAccessToken,
  setVettingForm,
  removeVettingFrom,
} = userSlice.actions;

export default userSlice.reducer;
